export default __webpack_public_path__ + "static/media/kshiritori.d64f7f16.png";